class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.init();
  }


  

  init() {
    this.setupEventListeners();
    this.setDefaultSelections();
  }

  setupEventListeners() {
    // Handle purchase option selection (radio button change)
    this.querySelectorAll('input[name="purchase_option"]').forEach((radio) => {
      radio.addEventListener("change", (e) => {
        this.handlePurchaseOptionChange(e.target);
        
        //Let the Sticky ATC know the PDP re-rendered
        const productInfoUpdatedEvent = new CustomEvent('productInfoUpdated');
        document.dispatchEvent(productInfoUpdatedEvent);
      });
    });

    // Handle frequency selection
    this.querySelectorAll(".subscription-widget__frequency-option").forEach(
      (freq) => {
        freq.addEventListener("click", (e) => {
          e.stopPropagation();
          this.selectFrequency(freq);
        });
      }
    );
  }

  handlePurchaseOptionChange(selectedRadio) {
    const isSubscription = selectedRadio.value === "subscription";
    
    // Trigger custom event for other scripts to listen
    this.dispatchEvent(
      new CustomEvent("subscription-widget:change", {
        detail: {
          type: selectedRadio.value,
          frequency: this.getSelectedFrequency(),
        },
      })
    );
  }

  selectFrequency(selectedFreq) {
    // Remove selected class from all frequency options
    this.querySelectorAll(".subscription-widget__frequency-option").forEach(
      (freq) => {
        freq.classList.remove("selected");
      }
    );

    // Add selected class to clicked frequency
    selectedFreq.classList.add("selected");

    // Trigger custom event
    this.dispatchEvent(
      new CustomEvent("subscription-widget:frequency-change", {
        detail: {
          frequency: selectedFreq.dataset.frequency,
          frequencyText: selectedFreq.textContent.trim(),
        },
      })
    );
  }

  getSelectedFrequency() {
    const selectedFreq = this.querySelector(
      ".subscription-widget__frequency-option.selected"
    );
    return selectedFreq ? selectedFreq.dataset.frequency : null;
  }

  setDefaultSelections() {
    // Set default frequency (30 days)
    const defaultFreq = this.querySelector(
      '.subscription-widget__frequency-option[data-frequency="30"]'
    );
    if (defaultFreq) {
      this.selectFrequency(defaultFreq);
    }
  }

  // Method to programmatically set the selection
  setSelection(type, frequency = null) {
    const radio = this.querySelector(`input[value="${type}"]`);

    if (radio) {
      radio.checked = true;
      this.handlePurchaseOptionChange(radio);
    }

    if (frequency && type === "subscription") {
      const freqOption = this.querySelector(`[data-frequency="${frequency}"]`);
      if (freqOption) {
        this.selectFrequency(freqOption);
      }
    }
  }
}

// Register the custom element
customElements.define("subscription-widget", SubscriptionWidget);

// Initialize widgets on page load
document.addEventListener("DOMContentLoaded", function () {
  const widgets = document.querySelectorAll("subscription-widget");
  widgets.forEach((widget) => {
    if (!widget.initialized) {
      widget.initialized = true;
    }
  });
});
